import React, { FC, useCallback, useMemo } from 'react'

import { colors } from '../../theme'
import Collapsable from '../Collapsable'
import Highlight, { HighlightProps } from '../Highlight'
import { ECollapsable } from '../Collapsable/types'

import * as SC from './styled'

export type RecipeIngredientsProps = {
  name: string
  units?: string
  weight?: string
  measurementUnit?: string
}

export type RecipeIngredientsSectionProps = {
  className?: string
  title?: string
  ingredients: RecipeIngredientsProps[]
  textSeasonalMessage?: string
  textPeople?: string
  textInsecable?: string
  textPlus?: string
  textMinus?: string
  isInsecable: boolean
  numberPeople: number
  numberMin?: number
  numberMax?: number
  onAddPerson?: () => void
  onRemovePerson?: () => void
  highlightTitleProps?: HighlightProps
}

const RecipeIngredientsSection: FC<RecipeIngredientsSectionProps> = (props) => {
  const {
    className,
    title,
    ingredients,
    textSeasonalMessage,
    textPeople,
    textInsecable,
    textPlus,
    textMinus,
    isInsecable,
    numberPeople,
    numberMin,
    numberMax,
    onAddPerson,
    onRemovePerson,
    highlightTitleProps,
  } = props

  const handleAddPerson = useCallback(() => {
    onAddPerson && onAddPerson()
  }, [onAddPerson])

  const handleRemovePerson = useCallback(() => {
    onRemovePerson && onRemovePerson()
  }, [onRemovePerson])

  const renderList = useMemo(() => {
    return ingredients.map((ingredient, index) => (
      <SC.ListItem key={`ingredient-${index}`}>
        <dt>{ingredient.name}</dt>
        <dd>
          {ingredient.units && <span>{ingredient.units}</span>}
          {ingredient.weight && !ingredient.units && (
            <span>{ingredient.weight}</span>
          )}
        </dd>
      </SC.ListItem>
    ))
  }, [ingredients])

  return (
    <Collapsable
      className={className}
      header={
        title && (
          <SC.SectionTitle>
            <Highlight
              backgroundColor={
                highlightTitleProps?.backgroundColor || colors.pink
              }
              color={highlightTitleProps?.color || colors.pureBlack}
              text={title ?? ''}
            />
          </SC.SectionTitle>
        )
      }
      isCollapsable={ECollapsable.MOBILE}
      isOpenOnInit
    >
      <SC.Inner>
        <SC.ControlNumber>
          <SC.ControlNumberButton
            actionProps={{
              onClick: () => handleRemovePerson(),
              disabled:
                numberPeople <= 0 ||
                numberPeople === numberMin ||
                isInsecable === true
                  ? true
                  : false,
            }}
            text={textMinus ?? ''}
            icon="minus"
            variantType="button"
            variantColorScheme="colored"
            variantIcon="only"
          />
          <span>{textPeople}</span>
          <SC.ControlNumberButton
            actionProps={{
              onClick: () => handleAddPerson(),
              disabled:
                (numberMax && numberPeople >= numberMax) || isInsecable === true
                  ? true
                  : false,
            }}
            text={textPlus}
            icon="plus"
            variantType="button"
            variantColorScheme="colored"
            variantIcon="only"
          />
        </SC.ControlNumber>
        {isInsecable && textInsecable && (
          <SC.Warning>{textInsecable}</SC.Warning>
        )}
        <SC.List $numberOfElements={ingredients.length}>{renderList}</SC.List>
        {textSeasonalMessage && <SC.Notes>{textSeasonalMessage}</SC.Notes>}
      </SC.Inner>
    </Collapsable>
  )
}

export default RecipeIngredientsSection
